class FAQs {

	constructor($target) {

		//Private properties
		$target;

		let name = "HELLO";

		function init(){
			dropDown()
		}

		function dropDown(){
			$('.block_faqs__question_wrapper').click( function (event) {
				event.stopPropagation();
				event.stopImmediatePropagation();
				
                var container = $(this).parents(".block_faqs__accordian");
                //console.log(container)
                var answer = container.find(".block_faqs__answer_wrapper");
                var trigger = container.find(".block_faqs__material_icons_drop");
                var state = container.find(".block_faqs__question_wrapper");
                
                answer.animate({height: "toggle"}, 100);
                
                if (trigger.hasClass("block_faqs__icon-expand")) {
                  	trigger.removeClass("block_faqs__icon-expand");
					state.removeClass("block_faqs__active");
				}
				
                else {
            		trigger.addClass("block_faqs__icon-expand");
					state.addClass("block_faqs__active");
                }
                
                if (container.hasClass("block_faqs__expanded")) {
                  	container.removeClass("block_faqs__expanded");
				}
				
                else {
					container.addClass("block_faqs__expanded");	
				}
				
            });
		}

		init()
		return {

			//Public properties
			name:name,

			publicBlockHero:function(string){

				// $target.append("HELLO!"+string);
				// console.log(name)
				// console.log(string)
				// console.log($target)

			}

		}

	}

}

export default FAQs;